// 身份证件类型
export const ID_CARD_TYPE = {
  RESIDENT_ID: 'A', // 居民身份证
  HOUSEHOLD_BOOK: 'B', // 户口簿
  PLA_ID: 'C', // 中国人民解放军军人身份证件
  PAP_ID: 'D', // 中国人民武装警察身份证件
  HK_MACAU_PASS: 'E', // 港澳居民来往内地通行证
  TAIWAN_PASS: 'F', // 台湾居民来往大陆通行证
  FOREIGN_PERMANENT_RESIDENCE: 'G', // 外国人永久居留证
  FOREIGN_PASSPORT: 'H', // 外国公民护照
  EID: 'I', // eID
  CTID: 'J', // CTID
  GO_TO_HK_MACAU_PASS: 'K', // 前往港澳通行证
  TO_HK_MACAU_PASS: 'M', // 往来港澳通行证
  E_PASSPORT: 'N', // 电子普通护照
  OVERSEAS_CHINESE_PASSPORT: 'Q', // 华侨护照
  HK_RESIDENCE_PERMIT: 'S', // 港澳居民居住证
  TAIWAN_RESIDENCE_PERMIT: 'T', // 台湾居民居住证
}

export const ID_CARD_TYPE_CN = {
  [ID_CARD_TYPE.RESIDENT_ID]: '居民身份证',
  [ID_CARD_TYPE.HOUSEHOLD_BOOK]: '户口簿',
  [ID_CARD_TYPE.PLA_ID]: '中国人民解放军军人身份证件',
  [ID_CARD_TYPE.PAP_ID]: '中国人民武装警察身份证件',
  [ID_CARD_TYPE.HK_MACAU_PASS]: '港澳居民来往内地通行证',
  [ID_CARD_TYPE.TAIWAN_PASS]: '台湾居民来往大陆通行证',
  [ID_CARD_TYPE.FOREIGN_PERMANENT_RESIDENCE]: '外国人永久居留证',
  [ID_CARD_TYPE.FOREIGN_PASSPORT]: '外国公民护照',
  [ID_CARD_TYPE.EID]: 'eID',
  [ID_CARD_TYPE.CTID]: 'CTID',
  [ID_CARD_TYPE.GO_TO_HK_MACAU_PASS]: '前往港澳通行证',
  [ID_CARD_TYPE.TO_HK_MACAU_PASS]: '往来港澳通行证',
  [ID_CARD_TYPE.E_PASSPORT]: '电子普通护照',
  [ID_CARD_TYPE.OVERSEAS_CHINESE_PASSPORT]: '华侨护照',
  [ID_CARD_TYPE.HK_RESIDENCE_PERMIT]: '港澳居民居住证',
  [ID_CARD_TYPE.TAIWAN_RESIDENCE_PERMIT]: '台湾居民居住证',
}

// 电话号码类型
export const PHONE_NUMBER_TYPE = {
  MOBILE: 1, // 手机号码
  LANDLINE: 2, // 固定号码
  TEL_400: 3, // 400电话
  TEL_800: 4, // 800电话
  TEL_95: 5, // 95开头号码
  TEL_96: 6, // 96开头电话
  TEL_1_START: 7, // 1开头号码（非手机号）
}

export const PHONE_NUMBER_TYPE_CN = {
  [PHONE_NUMBER_TYPE.MOBILE]: '手机号码',
  [PHONE_NUMBER_TYPE.LANDLINE]: '固定号码',
  [PHONE_NUMBER_TYPE.TEL_400]: '400电话',
  [PHONE_NUMBER_TYPE.TEL_800]: '800电话',
  [PHONE_NUMBER_TYPE.TEL_95]: '95开头号码',
  [PHONE_NUMBER_TYPE.TEL_96]: '96开头电话',
  [PHONE_NUMBER_TYPE.TEL_1_START]: '1开头号码（非手机号）',
}

// 短信模板审核状态：PENDING/APPROVED/REJECTED
export const SMS_TEMPLATE_AUDIT_STATUS = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
}

export const SMS_TEMPLATE_AUDIT_STATUS_CN = {
  [SMS_TEMPLATE_AUDIT_STATUS.PENDING]: '审核中',
  [SMS_TEMPLATE_AUDIT_STATUS.APPROVED]: '审核通过',
  [SMS_TEMPLATE_AUDIT_STATUS.REJECTED]: '审核驳回',
}
